import React from 'react';
import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = '' }) => (
  <nav aria-label="Breadcrumb" className={`flex items-center text-[12px] font-sans ${className}`}>
    {items.map((item, i) => {
      const last = i === items.length - 1;
      return (
        <React.Fragment key={i}>
          {item.href && !last ? (
            <Link href={item.href} className="text-v2-neutral-500 hover:text-v2-green-600 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className={last ? 'text-v2-green-600  font-medium' : 'text-v2-neutral-500'}>
              {item.label}
            </span>
          )}
          {!last && <ChevronRight size={12} strokeWidth={2} className="mx-2 text-v2-neutral-300" />}
        </React.Fragment>
      );
    })}
  </nav>
);
